import { Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface ColumnSelectionFooterProps {
  totals: { selected: number; total: number };
  onReset?: () => void;
  onDone: () => void;
}

export const ColumnSelectionFooter: React.FC<ColumnSelectionFooterProps> = ({
  totals,
  onReset,
  onDone,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ px: 2, py: 1.5, borderTop: `1px solid ${theme.palette.v4.border}` }}
    >
      {onReset && (
        <Button
          size="small"
          onClick={onReset}
          sx={{ color: theme.palette.v4.accentDark, textTransform: 'none' }}
        >
          Reset to default
        </Button>
      )}
      <Typography variant="caption" sx={{ flex: 1, color: theme.palette.text.secondary }}>
        {/* Clearing everything is allowed and recoverable, but it should never be
            a silent outcome — the grid behind the dialog may be scrolled away. */}
        {totals.total > 0 &&
          totals.selected === 0 &&
          'No columns selected — the table will be empty.'}
      </Typography>
      <Button variant="contained" size="small" onClick={onDone} sx={{ textTransform: 'none' }}>
        Done
      </Button>
    </Stack>
  );
};
